/* ================================================================
   WEBSITE STATUS (Checkpoint 40)
   ----------------------------------------------------------------
   Scans the actual JSON content libraries client-side for genuine
   placeholder/incomplete entries. Deliberately does NOT try to
   auto-classify Theme Settings as "gaps" — too many blank settings
   are intentional (a disabled feature, an off toggle), and a
   heuristic there produces false positives. That side is a short,
   hand-maintained list in page.status.liquid instead, updated each
   checkpoint alongside the handoff doc — same source either way,
   just less noisy than a generic scan.
================================================================ */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  function safeRun(label, fn) {
    try { fn(); } catch (e) {
      try { console.error('[lfj-status]', label, e); } catch (_e) {}
    }
  }

  function looksPlaceholder(str) {
    if (typeof str !== 'string') return false;
    return /placeholder|lorem ipsum|\btbd\b|set .* in admin/i.test(str);
  }

  function fetchJSON(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('fetch failed: ' + url);
      return r.json();
    });
  }

  function addRow(list, label, count, total, detail) {
    var li = document.createElement('li');
    li.className = 'lfj-status-row' + (count > 0 ? ' has-issues' : ' is-clean');
    li.innerHTML =
      '<span class="lfj-status-row-label">' + label + '</span>' +
      '<span class="lfj-status-row-count">' + count + (total != null ? ' / ' + total : '') + '</span>' +
      (detail ? '<span class="lfj-status-row-detail">' + detail + '</span>' : '');
    list.appendChild(li);
  }

  onReady(function () {
    safeRun('status scan', function () {
      var listEl = document.getElementById('lfjStatusList');
      var totalEl = document.getElementById('lfjStatusTotal');
      if (!listEl) return;

      var checks = [];

      checks.push(
        fetchJSON(window.LF_GALLERY_URL || '')
          .catch(function () { return null; })
          .then(function (data) {
            if (!data) return { label: 'Gallery items', count: 0, total: 0, detail: 'could not load gallery.json', error: true };
            var placeholders = data.filter(function (item) {
              return looksPlaceholder(item.title) || !item.thumbnail && !item.src;
            });
            return {
              label: 'Gallery items still placeholder',
              count: placeholders.length,
              total: data.length,
              detail: placeholders.map(function (p) { return p.category; }).join(', ')
            };
          })
      );

      checks.push(
        (window.LF_VIDEOS_READY || Promise.reject())
          .then(function () { return window.LF_CONFIG.videos || []; })
          .catch(function () { return null; })
          .then(function (data) {
            if (!data) return null;
            var missingThumb = data.filter(function (v) { return !v.thumbnail; });
            var needsTitle = data.filter(function (v) { return v._needs_real_title; });
            return [
              { label: 'Videos missing a thumbnail', count: missingThumb.length, total: data.length },
              { label: 'Videos with placeholder title (marked _needs_real_title)', count: needsTitle.length, total: data.length,
                detail: needsTitle.length ? needsTitle.map(function (v) { return v.key; }).join(', ') : '' }
            ];
          })
      );

      checks.push(
        fetchJSON(window.LF_WORKED_WITH_URL || '')
          .catch(function () { return null; })
          .then(function (data) {
            if (!data) return null;
            var noHandle = data.filter(function (w) { return !w.handle && !w.url; });
            return {
              label: '"Worked With" entries missing a handle/link',
              count: noHandle.length,
              total: data.length,
              detail: noHandle.length ? noHandle.map(function (w) { return w.name; }).slice(0, 6).join(', ') + (noHandle.length > 6 ? '…' : '') : ''
            };
          })
      );

      checks.push(
        fetchJSON(window.LF_ABOUT_ROSTER_URL || '')
          .catch(function () { return null; })
          .then(function (data) {
            if (!data) return null;
            var flat = [];
            if (Array.isArray(data)) {
              flat = data;
            } else if (data && typeof data === 'object') {
              Object.keys(data).forEach(function (tier) {
                (data[tier] || []).forEach(function (p) { flat.push(p); });
              });
            }
            var incomplete = flat.filter(function (p) {
              return !p.handle && !p.instagram && !p.role;
            });
            return {
              label: 'About roster entries missing a role/handle',
              count: incomplete.length,
              total: flat.length
            };
          })
      );

      Promise.all(checks).then(function (results) {
        var totalIssues = 0;
        var flat = [];
        results.forEach(function (r) {
          if (!r) return;
          if (Array.isArray(r)) { flat = flat.concat(r); } else { flat.push(r); }
        });
        flat.forEach(function (r) {
          if (!r.error) totalIssues += r.count;
          addRow(listEl, r.label, r.count, r.total, r.detail || (r.error ? '(skipped — file not found on this store)' : ''));
        });
        if (totalEl) {
          totalEl.textContent = totalIssues === 0
            ? 'All content libraries clean — nothing placeholder-looking found.'
            : totalIssues + ' item' + (totalIssues === 1 ? '' : 's') + ' across your content files still look unfinished.';
        }
      });
    });
  });
})();
